<template>
  <a class="copyright" href="https://maksis.by">
    developed in
    <img
      src="@/assets/image/maksis-logo.png"
      alt="Maksis digital agency logo"
    />
    Maksis digital agency
  </a>
</template>

<script>
export default {
  name: "Copyright"
};
</script>

<style lang="scss" scoped>
@import "@/assets/breackpoints.scss";

.copyright {
  font-size: 10px;
  color: #ffffff;
  text-transform: uppercase;
  display: flex;
  align-items: center;
  text-decoration: none;

  @media (max-width: $osx) {
    font-size: 8px;
  }

  &:hover {
    text-decoration: underline;
  }

  img {
    width: 35px;
    margin: 0 3px 0 10px;

    @media (max-width: $lg) {
      width: 25px;
    }
  }
}
</style>
